import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import configure from '../configure';

export default class HiddenForm extends Component {
  constructor() {
    super();
    this.state = {
      special: '',
      month: '',
      date: '',
      type: ''
    }
  }

  componentDidMount(){
    const form = ReactDOM.findDOMNode(this.refs.form);
    this.props.saveFormRef(form);
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps.data);
  }

  render() {
    if(!this.props.data)return null;
    let special = (this.props.data.special)?(<input type="hidden" name="special" value={this.state.special}/>):null;
    return (
      <form action={configure.API_URL()} method="post" ref="form">
        {special}
        <input type="hidden" name="month" value={this.state.month}/>
        <input type="hidden" name="date"  value={this.state.date}/>
        <input type="hidden" name="type"  value={this.state.type}/>
        <input type="hidden" name="item_code" value="000000"/>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./source/javascripts/components/hidden-form.js